var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { col: "6" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "text-h4 text--primary" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\tTest av SIE-fil " +
                          _vm._s(_vm.filename) +
                          "\n\t\t\t\t\t"
                      ),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _vm.errors
                        ? _c("v-btn", { on: { click: _vm.reset } }, [
                            _vm._v("\n\t\t\t\t\t\tTesta en ny fil\n\t\t\t\t\t"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.errors,
                          expression: "!errors",
                        },
                      ],
                    },
                    [
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.uploaded && !_vm.uploading,
                              expression: "!uploaded && !uploading",
                            },
                          ],
                          staticClass: "text--primary",
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\tHär kan du ladda upp en fil för test. Testapplikationen genererar då en felrapport som listar upptäckta fel i filen.\n\t\t\t\t\t"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("file-drop", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.uploaded && !_vm.uploading,
                            expression: "!uploaded && !uploading",
                          },
                        ],
                        on: {
                          uploaded: function ($event) {
                            return _vm.finishUploading($event)
                          },
                          uploading: _vm.startUploading,
                          failed: _vm.uploadFailed,
                        },
                      }),
                      _vm._v(" "),
                      _vm.uploading
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { align: "center" } },
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "secondary",
                                      size: 70,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.uploading
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-h4 text--primary",
                                  attrs: { align: "center" },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\tUppdaddning av filen pågår.\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.processing
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { align: "center" } },
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                      size: 70,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.processing
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-h4 text--primary",
                                  attrs: { align: "center" },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\tFilen analyseras på servern.\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.uploaded && !_vm.uploading,
                              expression: "!uploaded && !uploading",
                            },
                          ],
                          staticClass: "text--primary",
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\tUppladdade SIE-filer sparas på servern endast under den tid testrutinerna körs, och raderas omedelbart därefter.\n\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.errors
                ? _c(
                    "v-card",
                    { staticClass: "mt-5", attrs: { elevation: "2" } },
                    [
                      _c("v-card-title", { staticClass: "mb-0 pb-0" }, [
                        _vm._v("\n\t\t\t\t\tSammanfattning\n\t\t\t\t"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        _vm._l(
                          _vm.errors.summaryErrors,
                          function (item, index) {
                            return _c("div", { staticClass: "mb-0" }, [
                              item.level === "Header"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-subtitle-2 text--primary mt-5",
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(item.text) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.level === "Info"
                                ? _c(
                                    "span",
                                    { staticClass: "text--primary" },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "blue" } },
                                        [_vm._v("mdi-information")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(item.text) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.level === "Pass"
                                ? _c(
                                    "span",
                                    { staticClass: "text--primary" },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "green" } },
                                        [_vm._v("mdi-check")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(item.text) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.level === "Warning"
                                ? _c(
                                    "span",
                                    { staticClass: "text--primary" },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "orange" } },
                                        [_vm._v("mdi-alert")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(item.text) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.level === "Semi"
                                ? _c(
                                    "span",
                                    { staticClass: "text--primary" },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "red" } },
                                        [_vm._v("mdi-clipboard-alert")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(item.text) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.level === "Error"
                                ? _c(
                                    "span",
                                    { staticClass: "text--primary" },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "red" } },
                                        [_vm._v("mdi-alert-octagon")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(item.text) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.errors
                ? _c(
                    "v-card",
                    { staticClass: "mt-5", attrs: { elevation: "2" } },
                    _vm._l(_vm.errors.lineErrors, function (item, index) {
                      return _c("div", [
                        item.level === "Code"
                          ? _c("div", { staticClass: "code-background" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pa-0 ma-0 px-1 sie-code sie-code-line",
                                },
                                [_vm._v(_vm._s(item.line))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "pa-0 ma-0 pl-1 sie-code" },
                                [_vm._v(_vm._s(item.text))]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.level === "CodeRed"
                          ? _c("div", { staticClass: "code-background" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pa-0 ma-0 px-1 sie-code sie-code-line",
                                },
                                [_vm._v(_vm._s(item.line))]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "pa-0 ma-0 pl-1 sie-code",
                                domProps: { innerHTML: _vm._s(item.text) },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.level === "CodeBefore"
                          ? _c("div", { staticClass: "code-background" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "pa-0 ma-0 pl-1 sie-code-before",
                                },
                                [_vm._v(" ")]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.level === "CodeAfter"
                          ? _c("div", { staticClass: "code-background" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "pa-0 ma-0 pl-1 sie-code-after",
                                },
                                [_vm._v(" ")]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.level === "Info"
                          ? _c(
                              "span",
                              [
                                _c("v-icon", { attrs: { color: "blue" } }, [
                                  _vm._v("mdi-information"),
                                ]),
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(item.text) +
                                    "\n\t\t\t\t\t"
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.level === "Pass"
                          ? _c(
                              "span",
                              [
                                _c("v-icon", { attrs: { color: "green" } }, [
                                  _vm._v("mdi-check"),
                                ]),
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(item.text) +
                                    "\n\t\t\t\t\t"
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.level === "Warning"
                          ? _c(
                              "span",
                              [
                                _c("v-icon", { attrs: { color: "orange" } }, [
                                  _vm._v("mdi-alert"),
                                ]),
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(item.text) +
                                    "\n\t\t\t\t\t"
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.level === "Semi"
                          ? _c(
                              "span",
                              [
                                _c("v-icon", { attrs: { color: "red" } }, [
                                  _vm._v("mdi-clipboard-alert"),
                                ]),
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(item.text) +
                                    "\n\t\t\t\t\t"
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.level === "Error"
                          ? _c(
                              "span",
                              [
                                _c(
                                  "v-card-subtitle",
                                  { staticClass: "text-subtitle-2 py-2" },
                                  [
                                    _c("v-icon", { attrs: { color: "red" } }, [
                                      _vm._v("mdi-alert-octagon"),
                                    ]),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(item.text) +
                                        "\n\t\t\t\t\t\t"
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }